import { COLORS } from '@styles/colors'
import styled, { css } from 'styled-components'

export const Input = styled.input`
  border: 1px solid ${COLORS.nature[80]};
  border-radius: 5px;
  padding: 9px 16px;
  width: 100%;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.1px;
  color: ${COLORS.inputColor};

  &::placeholder {
    color: ${COLORS.inputPlaceholder};
  }

  &:focus {
    outline: none;
  }

  ${({ size }) =>
    size === 'small' &&
    `
      padding: 5px 12px;
    `}

  ${({ $hasError }) =>
    $hasError &&
    css`
      color: ${COLORS.error};

      &::placeholder {
        color: ${COLORS.error};
      }
    `}
`
